<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-card>
			<v-card-text class="text-center">
				<div class="pt-3 d-flex justify-center">
					<v-col cols="6">
						<v-img src="/assets/icon/confirm-vo.svg"></v-img>
					</v-col>
				</div>
				<div>
					{{ msg }}
					<span class="pl-1 font-weight-bold cl-primary cursor-pointer" @click="goToLink">klik disini</span>
					<span class="pl-1" v-if="msgTwo">{{ msgTwo }}</span>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			closeText: 'Tutup',
		}
	},
	props: {
		msg: String,
		msgTwo: String,
		link: String,
		routerType: String,
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		confirm() {
			this.$emit('action')
		},
		goToLink() {
			if (this.routerType) {
				this.$router.push({ name: this.link, params: { type: this.routerType } })
			} else {
				this.$router.push({ name: this.link })
			}
		},
	}
};
</script>